import { atom } from "recoil"
import { UserPerSite } from "../../api-client-nswag/custompermission-client"

export const usersInEntityState = atom<UserPerSite[]>({
  key: "usersInEntity/state",
  default: [],
})

export const usersPerSiteState = atom<UserPerSite[]>({
  key: "usersPerSite/state",
  default: [],
})

export const snapshotUsersInEntityState = atom<UserPerSite[]>({
  key: "snapshotUsersInEntity/state",
  default: [],
})